import dayjs from "dayjs";
import {
  IChannels
  //  IPlayer
} from "../type";

const basisOption = {
  bigPlayButton: true,
  errorDisplay: false,
  controls: true,
  autoplay: false,
  LiveDisplay: true,
  preload: "auto",
  language: "zh",
  techOrder: ["html5", "flash"],
  controlBar: {
    timeDivider: false,
    durationDisplay: false,
    vertical: true
  }
};

const format = {
  ymd: "YYYY-MM-DD",
  hms: "HH:mm",
  ymdhms: "YYYY-MM-DD HH:mm",
  hmss: "HH:mm:ss"
};

export const handlerStartEndTim = (start: number, end: number) => {
  const st = dayjs(start);
  const en = dayjs(end);
  if (st.format(format.ymd) === en.format(format.ymd)) {
    return `${st.format(format.ymdhms)} - ${en.format(format.hms)}`;
  } else {
    return `${st.format(format.ymdhms)} - ${en.format(format.ymdhms)}`;
  }
};

export const handelrHMS = (time: any) => {
  return dayjs(time).format(format.hmss);
};

export const durationDataString = (time: number) => {
  const dt = new Date().getTime();
  const duration = time - dt;
  let period: any;
  if (duration > 1000) {
    period = formatPeriod(duration);
  } else {
    period = null;
  }
  return period;
};

const formatPeriod = (ms: number) => {
  if (ms < 0) {
    return null;
  }

  const s = ms / 1000;

  const days = Math.floor(s / (24 * 60 * 60));
  const hours = Math.floor((s % (24 * 60 * 60)) / (60 * 60));
  const mins = Math.floor((s % (60 * 60)) / 60);
  const seconds = Math.floor(s % 60);

  return {
    days,
    hours: formatTimeToString(hours),
    mins: formatTimeToString(mins),
    seconds: formatTimeToString(seconds)
  };
};

const formatTimeToString = (n: number) => {
  if (n < 10) {
    return "0" + n;
  } else {
    return "" + n;
  }
};

export const handlerBrowserType = () => {
  let result: any;
  const userAgent = navigator.userAgent;
  const isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    result = "Opera";
  }
  if (userAgent.indexOf("Firefox") > -1) {
    result = "FF";
  }
  if (userAgent.indexOf("Chrome") > -1) {
    result = "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") < 1) {
    result = "Safari";
  }
  if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
    result = "IE";
  }
  return result;
};

export const handlerType = () => {
  const browse = handlerBrowserType() === "Safari";
  if (handlerIsMobile() || browse) {
    return "hls";
  } else {
    return "flv";
  }
};

export const handlerIsMobile = () => {
  const userAgent = navigator.userAgent;
  return /Mobile/.test(userAgent);
};

export const handlerVideoPlayerOptionMp4 = (src: any[]) => {
  const sources = src.map((item: string) => {
    return { src: item, type: "video/mp4" };
  });
  return {
    option: {
      errorDisplay: false,
      controls: true,
      autoplay: false,
      preload: "auto",
      language: "zh",
      controlBar: {
        timeDivider: false,
        durationDisplay: false
      }
    },
    sources
  };
};

export const handlerVideoParams = (path: any[]) => {
  let result: any;
  const browser = handlerBrowserType();

  if (browser === "Safari" || handlerIsMobile()) {
    result = videoPlayerHlsOption(path);
  } else {
    result = videoPlayerFalshOption(path);
  }

  return result;
};

// @ts-ignore
const handlerUaXy = () => {
  const userAgent = navigator.userAgent;
  if (/XYLINK/.test(userAgent) && /Android/.test(userAgent)) {
    return "hls";
  } else {
    return "native";
  }
};

const videoPlayerFalshOption = (path: any[]) => {
  const option = Object.assign(basisOption, {
    flash: {
      hls: {
        withCredentials: false
      }
    }
  });
  return { option, sources: filterSrc(path) };
};

const videoPlayerHlsOption = (path: any[]) => {
  const broadcastFormat = hlsOptions();

  const option = Object.assign(basisOption, {
    html5: broadcastFormat
      ? {
          hls: {
            withCredentials: false
          }
        }
      : {
          hls: {
            withCredentials: false,
            overrideNative: true
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        }
  });
  return { option, sources: filterSrc(path) };
};

const hlsOptions = () => {
  const ua = window.navigator.userAgent;
  const wx = /MicroMessenger/.test(ua);
  const android = /android/.test(ua.toLocaleLowerCase());
  const ios1231 = /12_3_1/.test(ua.toLocaleLowerCase());
  return (wx && android) || ios1231;
};

const filterSrc = (path: any[]) => {
  return path.map((e: IChannels) => {
    return filterOptionConfig(e);
  });
};

const filterOptionConfig = (e: IChannels) => {
  const option: any = {
    src: `${handleProtocol(e.src)}`
  };

  switch (e.resolution) {
    case "NORMAL_DEFINATION": {
      option.text = "标清";
      break;
    }
    case "HIGH_DEFINATION": {
      option.text = "高清";
      break;
    }
    case "SUPER_HIGH_DEFINATION": {
      option.text = "超高清";
      break;
    }
  }

  return option;
};

const handleProtocol = (src: string) => {
  const protocol = window.location.protocol;
  return src.replace(/^http:/, protocol);
};

export const locationXy = () => {
  const ua = navigator.userAgent;
  return /XYLINK/.test(ua);
};



// WEBPACK FOOTER //
// ./src/publics/tool/handler.ts